var _g, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 24 24",
    fill: "primary",
    className: "css-zbzjbd e11k6mr30",
    style: {
      minWidth: 40,
      minHeight: 40
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#whatsapp-color-24px_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1.832 21.893 1.432-5.216a10.029 10.029 0 0 1-1.347-5.035c0-5.553 4.529-10.068 10.091-10.068a10.11 10.11 0 0 1 7.138 2.952A10.073 10.073 0 0 1 22.1 11.65c-.002 5.554-4.53 10.068-10.092 10.068h-.004a10.1 10.1 0 0 1-4.822-1.225l-5.35 1.4Zm5.597-3.223.307.181a8.392 8.392 0 0 0 4.27 1.167h.002c4.624 0 8.386-3.755 8.388-8.369a8.356 8.356 0 0 0-2.454-5.92 8.388 8.388 0 0 0-5.93-2.454c-4.627 0-8.39 3.754-8.392 8.368a8.339 8.339 0 0 0 1.283 4.453l.2.317-.846 3.088 3.172-.83Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#whatsapp-color-24px_svg__b)",
    d: "m2.182 21.54 1.382-5.036a9.682 9.682 0 0 1-1.3-4.859c0-5.36 4.372-9.72 9.742-9.72a9.76 9.76 0 0 1 6.89 2.85 9.722 9.722 0 0 1 2.852 6.877c0 5.36-4.373 9.72-9.742 9.72h-.004a9.756 9.756 0 0 1-4.656-1.183l-5.164 1.352Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#whatsapp-color-24px_svg__c)",
    d: "m1.832 21.893 1.432-5.216a10.029 10.029 0 0 1-1.347-5.035c0-5.553 4.529-10.068 10.091-10.068a10.11 10.11 0 0 1 7.138 2.952A10.073 10.073 0 0 1 22.1 11.65c-.002 5.554-4.53 10.068-10.092 10.068h-.004a10.1 10.1 0 0 1-4.822-1.225l-5.35 1.4Zm5.597-3.223.307.181a8.392 8.392 0 0 0 4.27 1.167h.002c4.624 0 8.386-3.755 8.388-8.369a8.356 8.356 0 0 0-2.454-5.92 8.388 8.388 0 0 0-5.93-2.454c-4.627 0-8.39 3.754-8.392 8.368a8.339 8.339 0 0 0 1.283 4.453l.2.317-.846 3.088 3.172-.83Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M9.487 7.434c-.19-.42-.387-.427-.568-.435-.145-.006-.315-.006-.483-.006a.928.928 0 0 0-.673.315c-.23.252-.882.86-.882 2.099 0 1.238.903 2.434 1.03 2.602.126.168 1.744 2.79 4.306 3.799 2.129.838 2.564.672 3.026.628.46-.044 1.491-.61 1.702-1.197.21-.588.21-1.09.145-1.196-.065-.105-.231-.168-.484-.294-.252-.125-1.492-.735-1.723-.818-.231-.084-.4-.126-.567.126-.169.252-.651.818-.799.986-.147.168-.294.19-.546.063-.252-.126-1.065-.391-2.028-1.248-.75-.668-1.258-1.491-1.403-1.743-.145-.252-.015-.387.111-.514.113-.113.252-.294.378-.44.127-.147.168-.252.252-.42.085-.168.043-.315-.02-.441-.064-.126-.55-1.369-.774-1.866Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "whatsapp-color-24px_svg__b",
    x1: 11.965,
    x2: 11.965,
    y1: 21.541,
    y2: 1.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20B038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D66A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "whatsapp-color-24px_svg__c",
    x1: 11.966,
    x2: 11.966,
    y1: 21.893,
    y2: 1.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "whatsapp-color-24px_svg__a",
    width: 22.268,
    height: 22.318,
    x: 0.832,
    y: 1.574,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_119_15"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_119_15",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsApp);
export default __webpack_public_path__ + "static/media/WhatsApp.34dc69b2867d102c7f754ea528beeecd.svg";
export { ForwardRef as ReactComponent };